<div *ngIf="grid">
  <h5>Apply Heatmap</h5>
  <p>
    Select a metric column.
  </p>
  <siq-js-heatmap-selector
    [gridComponent]="grid"
  ></siq-js-heatmap-selector>
</div>
